import { Link, StatusIndicator, TableProps } from '@cloudscape-design/components';
import { ROLES_LABELS } from 'src/contstant/commonLabels';
import { UserDetailsV2 } from '@amzn/gbsa-orbit-typescript-client';

export const getUsersTableDefinition =
  (): TableProps.ColumnDefinition<UserDetailsV2>[] => {
    return [
      {
        id: 'alias',
        header: 'Alias',
        cell: (item) => (
          <Link
            href={`https://phonetool.amazon.com/users/${item.userPermission.userId}`}
            external={true}
          >
            {item.userPermission.userId}
          </Link>
        ),
      },
      {
        id: 'fullname',
        header: 'Full Name',
        cell: (item) => item.userPermission.userName ?? '-',
      },
      {
        id: 'role',
        header: 'Role',
        cell: (item) =>
          ROLES_LABELS[item.userPermission.roleId as keyof typeof ROLES_LABELS],
      },
      {
        id: 'business_unit_code',
        header: 'Business Unit',
        cell: (item) => item.userPermission.businessUnit,
      },
      {
        id: 'divisions',
        header: 'Divisions',
        cell: (item) => {
          const divisions = item.userPermission?.divisions;
          return divisions?.length ? divisions.join(', ') : '-';
        },
      },

      {
        id: 'isUserActive',
        header: 'Status',
        cell: (item) => {
          const status = item.userPermission.isUserActive;
          return (
            <StatusIndicator type={status ? 'success' : 'error'}>
              {status ? 'Active' : 'Inactive'}
            </StatusIndicator>
          );
        },
      },
      {
        id: 'ExpiryDate',
        header: 'Permission Expiry',
        cell: (item) =>
          item?.userPermission?.permissionExpirationDate?.toLocaleString() || '-',
      },
      {
        id: 'createdBy',
        header: 'Created By',
        cell: (item) => item.userPermission.createdBy || '-',
      },
      {
        id: 'createdAt',
        header: 'Created At',
        cell: (item) => item.userPermission.createdAt?.toLocaleString() || '-',
      },
      {
        id: 'lastUpdatedBy',
        header: 'Updated By',
        cell: (item) => item.userPermission.lastUpdatedBy || '-',
      },
      {
        id: 'lastUpdatedAt',
        header: 'Updated At',
        cell: (item) => item.userPermission.lastUpdatedAt?.toLocaleString() || '-',
      },
    ];
  };
